module.exports = __webpack_public_path__ + "static/media/card4.43d2100a.png";